import { BaseDto } from "../common/baseDto";

export interface EqmMoldCleanDto extends BaseDto {

	moldCleanNo: string;
	compCd: string;
	moldCd: string;
	cleanDt: Date;
	cleanType: string;
	cleanWorker: string;
	cleanResult: string;
	shotCount: number;
	nextCleanShot: number;
	remark: string;

	inserted: boolean;
	isModified: boolean;
}

export const defaultEqmMoldCleanDto: EqmMoldCleanDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	moldCleanNo: '',
	compCd: '',
	moldCd: '',
	cleanDt: new Date(),
	cleanType: '',
	cleanWorker: '',
	cleanResult: '',
	shotCount: 0,
	nextCleanShot: 0,
	remark: '',

	inserted: false,
	isModified: false,
};
